import { render, staticRenderFns } from "./duration-terms.vue?vue&type=template&id=30e5e4fd&"
import script from "./duration-terms.vue?vue&type=script&lang=js&"
export * from "./duration-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports